module.exports = __webpack_public_path__ + "media/recupel2.d6772f63.mp4";